module.exports = __webpack_public_path__ + "img/yamaxun.4813383e.png";